export class InvalidCardExpirationDateError extends Error {
  constructor() {
    super('The card expiration date format is invalid');
  }
}
